module.exports = __webpack_public_path__ + "static/cloudbeds-example.e9d7ee99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloudbeds-example.png
// module id = 169
// module chunks = 43530729963404 237044687278113